module.exports = __webpack_public_path__ + "img/pd-img41.e67e3860.jpg";